export function initSelect() {
    if (window.screen.width <= 768) {
        document.querySelectorAll('[data-select]').forEach((element) => {
            destroySelect(element);
        });
    } else {
        document.querySelectorAll('[data-select]').forEach((element) => {
            buildSelect(element);
        });
    }

    window.addEventListener('resize', (e) => {
        if (window.screen.width <= 768) {
            document.querySelectorAll('[data-select]').forEach((element) => {
                destroySelect(element);
            });
        } else {
            document.querySelectorAll('[data-select]').forEach((element) => {
                buildSelect(element);
            });
        }
    });
}

function destroySelect(element) {
    const select = element.querySelector('select');
    const selected = element.querySelector('.selected');
    const ul = element.querySelector('ul.dropdown-list');
    const jsSelect = element.querySelector('.js-select');

    if (selected) {
        select.setAttribute('id', selected.getAttribute('id'));
        select.setAttribute('name', selected.getAttribute('name'));
        selected.remove();

        const parent = jsSelect.parentNode;
        while (jsSelect.firstChild) {
            parent.insertBefore(jsSelect.firstChild, jsSelect);
        }
        parent.removeChild(jsSelect);
    }

    if (ul) ul.remove();

    select.style.display = '';
}

function buildSelect(element) {

    if (element.querySelector('.js-select')) {
        return;
    }

    const select = element.querySelector('select');
    select.style.display = 'none';

    const wrapper = document.createElement('div');
    wrapper.classList = 'js-select';
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    const placeholder = element.getAttribute('data-select-placeholder');
    const nameAttr = select.name ? `name="${select.name}"` : '';
    select.insertAdjacentHTML('afterend', '<ul class="dropdown-list" style="display: none"></ul>')
    select.insertAdjacentHTML('beforebegin', `<input class="selected" type="text" id="${select.id}" ${nameAttr} placeholder="${placeholder}"/>`)
    select.removeAttribute('id');
    select.removeAttribute('name');

    const defaultSelected = element.getAttribute('data-select-selected');
    const selected = element.querySelector('.selected');
    const ul = element.querySelector('ul.dropdown-list');
    const jsSelect = element.querySelector('.js-select');

    if (defaultSelected) {
        select.value = defaultSelected;
    }

    updateSelect(element);

    document.addEventListener('click', (e) => {
        if ( !jsSelect.contains(e.target) ) {
            ul.style.display = 'none';
            jsSelect.classList.remove('select-open');
        }
    });

    const selectedOption = select.options[select.selectedIndex];
    selected.value = selectedOption && selectedOption.text ? selectedOption.text : defaultSelected;
    selected.addEventListener('click', (e) => {
        if (e.defaultPrevented) return;
        ul.style.display = 'block';
        jsSelect.classList.add('select-open');
    });

    selected.addEventListener('input', () => {
        element.querySelectorAll('ul.dropdown-list li').forEach((li) => {
            if (li.textContent.toLowerCase().startsWith(selected.value.toLowerCase())) {
                li.style.display = '';
            } else {
                li.style.display = 'none';
            }
        })
    });

    MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    const observer = new MutationObserver(() => {
        updateSelect(element);
    });

    observer.observe(select, {
        childList: true,
    });
}

function updateSelect(element) {
    let html = '';
    const ul = element.querySelector('ul.dropdown-list');
    const select = element.querySelector('select')
    const selected = element.querySelector('.selected');

    ul.replaceChildren();
    select.querySelectorAll('option').forEach((option) => {
        const name = option.innerText;
        const value = option.value ?? name;
        let attributes = option.hasAttribute('selected') ? `data-selected="true"` : '';
        attributes += value ? ` data-value="${value}"` : '';
        attributes += name ? ` data-name="${name}"` : '';

        if (option.attributes) {
            for (const attr of option.attributes) {
                attributes += attr.name + '="' + attr.value +'"';
            }
        }

        html += `<li ${attributes}>${name}</li>`;
    });
    ul.insertAdjacentHTML('afterbegin', html);

    ul.addEventListener('click', (e) => {
        if (e.target.matches('li')) {
            select.value = e.target.getAttribute('data-value');
            selected.value = e.target.getAttribute('data-name');

            if (e.target.attributes) {
                for (const attr of e.target.attributes) {
                    selected.setAttribute(attr.name, attr.value);
                }
            }

            select.dispatchEvent(new Event('change'));
            selected.dispatchEvent(new Event('change'));

            ul.style.display = 'none';
            element.querySelector('.js-select').classList.remove('select-open');
            setTimeout(() => {
                ul.style.display = 'none';
                element.querySelector('.js-select').classList.remove('select-open');
            }, 100);
        }
    })
}

export function setSelectOptions(element, data) {
    let html = '<option></option>';
    const select = element.parent().find('select');
    for (let i = 0; i < data.length; i++) {
        html += '<option value="'+ data[i][1] +'">'+ data[i][0] +'</option>';
    }
    select.html(html);
}